import { render, staticRenderFns } from "./certonjobdetail.vue?vue&type=template&id=4c54b6e1&scoped=true&"
import script from "./certonjobdetail.vue?vue&type=script&lang=js&"
export * from "./certonjobdetail.vue?vue&type=script&lang=js&"
import style0 from "./certonjobdetail.vue?vue&type=style&index=0&id=4c54b6e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54b6e1",
  null
  
)

export default component.exports